/* global paths:[] */
import {backAudio} from "../classes/backAudio";
// import {Stickyfill} from 'stickyfilljs';
import * as Stickyfill from 'stickyfilljs';

export default {
  init() {
    // JavaScript to be fired on all pages
    this.seoText();

  },
  seoText() {
    $(document).on('click', '.seo_text_more', function (e) {
      e.preventDefault();
      $('.seo_text').removeClass('seo_text_hide');
      $(this).find('a').remove();
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    (function ($) {

      $(function () {
        if ($('[data-style=select2]')) {
          let selectTemplates = {
            svg: function (state) {
              if (!state.id) {
                return state.text;
              }

              var baseUrl = paths.dist.uri + "/img/";
              var $state = $('<img />', {
                src: baseUrl + state.element.value.toLowerCase() + '.svg',
                class: 'icon-img'
              });

              return $state;
            }
          };


          $('[data-style=select2]').each(function () {
            var $cont = $(this),
              cont = $cont.get(0),
              $select = $cont.find('select'),
              args = {minimumResultsForSearch: -1};

            if ($cont.prop("tagName") === 'SELECT') {
              $select = $cont;
            }

            if (cont.dataset.theme) {
              args['theme'] = cont.dataset.theme;
            }

            if (cont.dataset.width) {
              args['width'] = cont.dataset.width;
            }

            if (cont.dataset.template) {
              args['templateResult'] = selectTemplates[cont.dataset.template];
              args['templateSelection'] = selectTemplates[cont.dataset.template];
            }

            $select.width($select.outerWidth() + 5);
            $select.addClass('transform-select');
            $select.select2(args);
          });
        } // End Select2

        function formPlaceholder(selector) {
          let el = selector.find('input, textarea');
          el.each(function () {
            if ($(this).val().length > 0) {
              $(this).parent().parent().toggleClass('focus');
            }
          });
        }

        formPlaceholder($('[data-style=ajax-focus]'));
        formPlaceholder($('.product-form'));

        $('[data-style=ajax-focus]').find('input, textarea').on('focusin focusout', function () {
          if ($(this).val().trim() === '') {
            $(this).parent().parent().toggleClass('focus');
          }
        });

        $('.product-form').find('input, textarea').on('focusin focusout', function () {
          if ($(this).val().trim() === '') {
            $(this).parent().parent().toggleClass('focus');
          }
        });

        $('body').on('click', '[data-toggle-class]', function () {
          var $but = $(this),
            cls = $but.data('toggle-class'),
            $target = $but.closest($but.data('target'));

          $target.toggleClass(cls);
        });

        $('[data-id=currency]').on('select2:select', function (e) {
          let data = e.params.data;
          let pattern = new RegExp("min_price=[0-9]+\&max_price=[0-9]+"); //eslint-disable-line

          // console.log( window.location.href.replace(pattern,'') );

          let $form = $('<form />', {
            method: 'POST',
            action: window.location.href.replace(pattern, '')
          });

          let $input = $('<input />', {
            type: 'hidden',
            name: 'currency',
            value: data.id
          });

          // console.log($input);
          // console.log($form);

          $form.append($input);
          $('body').append($form);
          $form.submit();
        });

        if ($('.woocommerce-product-gallery').length) {
          let swiperInfo = new Swiper('.woocommerce-product-gallery', { // eslint-disable-line
            wrapperClass: 'woocommerce-product-gallery__wrapper',
            slideClass: 'woocommerce-product-gallery__image',
            slidesPerView: 1,
            centeredSlides: true,
            speed: 600,
            navigation: {
              nextEl: '.woocommerce-product-gallery__image-next',
              prevEl: '.woocommerce-product-gallery__image-prev',
            },
          });

          let item = $('.woocommerce-product-gallery__image a');
          if (item.length) {
            item.attr('data-fancybox', 'gallery');
            item.fancybox({
              beforeClose: function (instance) {
                // This is index of current fancyBox slide
                // console.info( instance.currIndex  );

                // Update position of the slider
                swiperInfo.slideTo(instance.currIndex, 0);

              }
            });
          }
        }
      });

      var elements = document.querySelectorAll('.widget_contactformwidget');
      Stickyfill.add(elements);
    })(jQuery);

    // window.onload = function() {
    // new AudioContext();

    // let audio = document.getElementById('background-music');
    //
    //
    // if (audio) {
    //   // let source = audio.querySelector('source').getAttribute('src');
    //   console.log(audio);
    //   // audio.autoplay = true;
    //   // audio.load();
    //   var playPromise = audio.play();
    //
    //     if (playPromise !== null){
    //       playPromise.catch(() => { audio.play(); })
    //     }
    // }

    new backAudio();
  }
};
